import * as Accordion from "@radix-ui/react-accordion";
import { useInstantSearch } from "react-instantsearch";
import { cn } from "@/lib/utils";
import Icon from "@/components/icons";
import { useProductCreatedRange } from "../SearchContextProvider";
import useSearchPageTemplate from "@/monarch/rules/searchPageTemplate/useSearchPageTemplate";
import getDefaultDateRange from "@/components/Search/utils/getDefaultDateRange";
import useFormEvents from "@/hooks/eventing/useFormtEvents";
import { buildRecentlyAddedFieldEvent } from "@/components/Search/utils/buildRecentlyAddedFieldEvent";

function RecentlyAddedAccordionItem() {
  const {
    productCreatedRange,
    setProductCreatedRange,
    clearProductCreatedRange,
  } = useProductCreatedRange();
  const searchPageTemplateResult = useSearchPageTemplate();
  const monarchRange = searchPageTemplateResult?.data?.productCreatedRange;
  const filterLabel = monarchRange?.filterLabel || "Recently added";
  const filterOptionLabel = monarchRange?.filterOptionLabel || "Yes";
  const { fieldSelected } = useFormEvents({});
  const { status } = useInstantSearch();

  if (status !== "idle") {
    return null;
  }

  const isSelected = productCreatedRange !== null;

  const handleToggle = () => {
    if (typeof window !== "undefined") {
      const formEvent = buildRecentlyAddedFieldEvent(
        "search-filters-modal",
        filterLabel,
        filterOptionLabel,
        isSelected,
      );
      fieldSelected(formEvent);
    }
    if (isSelected) {
      clearProductCreatedRange();
    } else {
      const rangeToUse = monarchRange || getDefaultDateRange();
      setProductCreatedRange(rangeToUse);
    }
  };

  return (
    <Accordion.Item value="recently-added" className="border-b">
      <Accordion.Header className="flex m-0">
        <Accordion.Trigger
          className={cn(
            "[&[data-state=open]]:bg-putty-200 flex flex-1 py-2 px-5 items-center justify-between text-lg text-left font-bold transition-all [&[data-state=open]>svg]:rotate-180",
            "text-[1.125rem] h-12 font-semibold pr-4",
          )}
        >
          {filterLabel}
          {isSelected ? " (1)" : ""}
          <Icon
            type="keyboard-arrow-down-material"
            pathProps={{
              fill: "#000000ff",
            }}
            svgProps={{
              fill: "#000000ff",
              className: `${cn(
                "h-5 w-5 shrink-0 text-brand font-bold transition-transform duration-200",
                "text-gray-700 color-gray-700",
              )}`,
            }}
          />
        </Accordion.Trigger>
      </Accordion.Header>
      <Accordion.Content
        className={cn(
          "overflow-hidden text-sm data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down",
          "relative -mx-5",
        )}
      >
        <div className="px-5">
          <div className="py-2 gap-2">
            <div className="px-5">
              <div
                className="py-2 flex justify-start items-start cursor-pointer"
                onClick={handleToggle}
              >
                <input
                  type="checkbox"
                  id="recently-added-yes"
                  checked={isSelected}
                  readOnly
                  className="border-2 mr-2 border-gray-700 min-w-4 h-5 w-5 cursor-pointer"
                />
                <label
                  htmlFor="recently-added-yes"
                  className="text-gray-700 flex items-center mb-0 leading-5 cursor-pointer"
                >
                  {filterOptionLabel}
                </label>
              </div>
            </div>
          </div>
        </div>
      </Accordion.Content>
    </Accordion.Item>
  );
}

export default RecentlyAddedAccordionItem;
